export enum TrackingServices {
    googleAnalytics = 1,
    amplitude,
    intercom,
}

export enum CampaignsAction {
    SingleEventCampaignClick = 'Create Single Event Invite',
    MultiEventCampaignClick = 'Create Multi Event Campaign',
    CampaignCreated = 'CampaignCreated',
    CampaignView = 'CampaignView',
}

export enum EventsAction {
    EventCardClick = 'Clicked Event Card Rec',
}

export enum AnalyticsCategory {
    default = 'MarketingTools',
    EmailCampaigns = 'EmailCampaigns',
    EventbriteBoost = 'EventbriteBoost',
}

export enum IntercomUpdateKey {
    ClickedSingleEventEmail = 'ClickedSingleEventEmail',
    ClickedMultiEventEmail = 'ClickedMultiEventEmail',
}
